import Routes from 'constants/routes';
import SwitchWithRedirect from 'components/SwitchWithRedirect';
import branch from 'hocs/branch';
import { Error404 } from '../../../pages';

import AppContent from './AppContent';
import AppShell from './AppShell';

const MainView = ({ location }) => (
  <AppShell pathname={location.pathname}>
    <SwitchWithRedirect location={location}>
      {Routes.map((route, key) => (
        <AppContent {...route} location={location} key={key} />
      ))}
    </SwitchWithRedirect>
  </AppShell>
);

export default branch(Error404, MainView);
